import {
  string,
  number,
  boolean,
  array,
  object,
  rangeNumber,
} from '@gogame/schemas';

import * as ACTIVITY_FIELDSET from './ActivityFieldSet/constants';
import * as AUDIENCE_TYPES_FIELDSET from './AudienceTypesFormField/constants';
import * as DEPOSITORS_FIELDSET from './DepositorsFieldSet/constants';
import * as ENGAGEMENT_EVENTS_FIELDSET from './EngagementEventsFormField/constants';
import * as GENERAL_FIELDSET from './GeneralFieldSet/constants';
import * as POPULATION_FIELDSET from './PopulationFieldSet/constants';
import {
  ACTIVITY,
  AUDIENCE_TYPES,
  DEPOSITORS,
  ENGAGEMENT_EVENTS,
} from './constants';

export const AudienceFormValidationSchema = object({
  [GENERAL_FIELDSET.NAME]: string().required('Name  is required'),
  [POPULATION_FIELDSET.NETWORKS]: array().required('Networks  is required'),
  [POPULATION_FIELDSET.PLATFORMS]: array().required('Platforms  is required'),
  [POPULATION_FIELDSET.DEVICES]: array(),
  [POPULATION_FIELDSET.OSVERSIONS]: array(),
  [POPULATION_FIELDSET.APPLICATIONS]: array().required(
    'Applications  is required'
  ),
  [POPULATION_FIELDSET.EXCLUDE_APPLICATIONS]: array(),
  [POPULATION_FIELDSET.TRAFFIC_TYPE]: number().required(
    'Traffic Types  is required'
  ),
  [POPULATION_FIELDSET.AFFILIATES]: array(),
  [POPULATION_FIELDSET.COUNTRIES]: array(),
  [ACTIVITY]: object({
    [ACTIVITY_FIELDSET.REG_PERIOD]: object().required(
      'Registration period is required'
    ),
    [ACTIVITY_FIELDSET.ACTIVITY_PERIOD]: object().required(
      'Last activity period is required'
    ),
    [ACTIVITY_FIELDSET.USER_LEVEL]: rangeNumber(),
    [ACTIVITY_FIELDSET.DAYS_OFFLINE]: rangeNumber(),
    [ACTIVITY_FIELDSET.SENIORITY_DAYS]: rangeNumber(),
    [ACTIVITY_FIELDSET.RE_COUNTER]: rangeNumber(),
  }),
  [AUDIENCE_TYPES]: array().required('Purchase data  is required'),
  [DEPOSITORS]: object().when(AUDIENCE_TYPES, (audienceTypes, schema) => {
    const isAll =
      Array.isArray(audienceTypes) &&
      audienceTypes.length ===
        Object.keys(AUDIENCE_TYPES_FIELDSET.NAMES).length;
    const hasRegular =
      Array.isArray(audienceTypes) &&
      audienceTypes.includes(AUDIENCE_TYPES_FIELDSET.REGULAR);
    if (isAll || !hasRegular) {
      return schema;
    }

    return schema.shape({
      [DEPOSITORS_FIELDSET.PERIOD]: object(),
      [DEPOSITORS_FIELDSET.DAYS_TO_DEPOSIT]: number(),
      [DEPOSITORS_FIELDSET.DAYS_SINCE_LAST_DEPOSIT]: number(),
      [DEPOSITORS_FIELDSET.AMOUNT]: rangeNumber(),
      [DEPOSITORS_FIELDSET.COUNT]: rangeNumber(),
    });
  }),
  [ENGAGEMENT_EVENTS]: array(
    object({
      [ENGAGEMENT_EVENTS_FIELDSET.EVENT]:
        string().required('Event is required'),
      [ENGAGEMENT_EVENTS_FIELDSET.VALUE]:
        boolean().required('Value is required'),
    })
  ),
});
